/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2022, Zumper
 * @description STR List Card Amenity Utils
 */

import type { Listable } from '@zcode/state-type'

const KITCHEN = 'Kitchen'
const WORKSPACE = 'Workspace'
const BALCONY = 'Balcony'
const GARDEN = 'Garden'
const DECK = 'Deck'
const OUTDOOR_SPACE = 'Outdoor Space'
const WALK_IN_CLOSETS = 'Walk In Closets'

const otherSpacesValues = [
  KITCHEN,
  WORKSPACE,
  BALCONY,
  GARDEN,
  DECK,
  WALK_IN_CLOSETS,
  OUTDOOR_SPACE,
] as const

function isOtherSpace(
  amenity: Listable['combinedAmenities'][number]
): amenity is typeof amenity & (typeof otherSpacesValues)[number] {
  return otherSpacesValues.includes(amenity)
}

function aintOtherSpace(
  amenity: Listable['combinedAmenities'][number]
): amenity is Exclude<typeof amenity, (typeof otherSpacesValues)[number]> {
  return !isOtherSpace(amenity)
}

export const getListCardAmenities = (amenitiesGroup: Listable['combinedAmenities']) => {
  const otherSpaces = amenitiesGroup.filter(isOtherSpace)
  const amenitiesList = amenitiesGroup.filter(aintOtherSpace)

  const otherSpacesBlurb = getOtherSpacesBlurb(otherSpaces)
  const amenitiesBlurb = getAmenitiesBlurb(amenitiesGroup)

  return { amenitiesList, otherSpacesBlurb, amenitiesBlurb } as const
}

const getOtherSpacesBlurb = (otherSpaces: Listable['combinedAmenities']) => {
  if (otherSpaces.some((item) => item === BALCONY || item === GARDEN || item === DECK)) {
    return otherSpaces.filter((item) => item !== OUTDOOR_SPACE).join(', ')
  }

  return otherSpaces.join(', ')
}

const getAmenitiesBlurb = (amenities: readonly string[]) => {
  switch (amenities.length) {
    case 0:
      return ''
    case 1:
      return amenities[0]
    case 2:
      return `${amenities[0]} · ${amenities[1]}`
    default:
      return `${amenities[0]} · ${amenities[1]} · ${amenities[2]}`
  }
}
